<script>
import { mapState } from 'vuex';
import Wishlist from '@phoenix/mixins/components/myAccount/Wishlist';
import ProductCard from '../product/ProductCard.vue';
import ProductPrice from '@phoenix/components/common/ProductPrice';

export default {
  components: {
    ProductCard,
    ProductPrice,
  },

  mixins: [Wishlist],

  data() {
    return {
      loadOnCreate: false,
    };
  },

  computed: {
    ...mapState('myAccount', ['menuLinks']),

    ...mapState('currentUser', ['isLogged']),
  },
};
</script>

<template>
  <div class="wishlist-panel">
    <template v-if="products.length > 0">
      <ul class="list list--stacked list--md">
        <li v-for="product in products" :key="product.modelReference">
          <ProductCard
            v-bind="product"
            :reference="product.modelReference"
            :sap-reference="product.sapReference"
            :reference-text="product.referenceText"
            :labels="product.labels"
            :image="product.imageProductKey"
            :vat-information="vatInformation(product.price)"
            :should-display-add-to-wishlist="true"
            :show-tags="false"
            :tight="true"
            :horizontal="true"
            :show-reference="true"
            :show-vat="false"
            :lazy="false"
            default-in-wishlist-icon="close"
            small-price
          >
            <template #price>
              <product-price v-bind="localizePrice(product.price)"></product-price>
            </template>
          </ProductCard>
        </li>
      </ul>
    </template>
    <template v-else>
      <div class="uppercase">
        {{ $t('Wishlist.emptyWishlist') }}
      </div>
    </template>

    <template v-if="!isLogged">
      <hr class="divider" />

      <div class="wishlist-panel__create-account-section">
        <h4>{{ $t('MyAccount.orCreateANewOne') }}</h4>
        <small class="wishlist-panel__create-account-section-infos">
          {{ $t('MyAccount.orCreateANewOneText') }}
        </small>

        <div class="panel__actions">
          <a :href="menuLinks.guestLinks.accountCreate" class="btn btn--secondary" data-panel-close="mobile-menu-panel">
            <span class="btn__text">{{ $t('MyAccount.createMyAccount') }}</span>
          </a>
        </div>
      </div>
    </template>

    <div v-if="isLoading" class="loader-overlay loader-overlay--light">
      <div class="loader loader--dark loader--lg">
        <div class="loader__inner"></div>
      </div>
    </div>
  </div>
</template>
